import React from 'react';
import { CalendarIcon, ShieldIcon, SparklesIcon, BrainIcon, ClockIcon, ArrowRightIcon, XIcon, CheckIcon } from 'lucide-react';
const rows = [{
  icon: CalendarIcon,
  category: 'Planificación',
  before: 'Noches de insomnio buscando drills en YouTube que no conectan entre sí.',
  after: '–90% de tiempo. Sesiones hiladas y progresivas listas para ejecutar.'
}, {
  icon: ShieldIcon,
  category: 'Seguridad',
  before: 'Temor a lesiones en el contacto por falta de una progresión técnica clara.',
  after: 'Protocolos paso a paso de Tackle, Ruck y Scrum seguro.'
}, {
  icon: SparklesIcon,
  category: 'Variedad',
  before: 'Entrenamientos monótonos que aburren al jugador y estancan el aprendizaje.',
  after: '+200% de originalidad. Drills dinámicos que mantienen al equipo enfocado.'
}, {
  icon: BrainIcon,
  category: 'Energía mental',
  before: 'Llegas al club estresado, repasando el plan en el coche a último momento.',
  after: 'Liderazgo puro. Llegas con claridad mental para corregir y potenciar jugadores.'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-118">
      {/* Background accents */}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[140px] pointer-events-none" aria-hidden="true" data-id="element-119"></div>
      <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-cta-green/5 rounded-full blur-[120px] pointer-events-none" aria-hidden="true" data-id="element-120"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-121">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14" data-id="element-122">
          <span className="inline-flex items-center gap-2 text-primary font-bold text-xs sm:text-sm tracking-widest uppercase bg-primary/10 px-4 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-123">
            <SparklesIcon className="w-4 h-4" aria-hidden="true" data-id="element-124" />
            La Transformación
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight leading-tight" data-id="element-125">
            Del <span className="text-badge-red" data-id="element-126">caos</span> a la{' '}
            <span className="text-primary" data-id="element-127">excelencia táctica</span>
          </h2>
          <p className="text-text-sec text-base sm:text-xl max-w-3xl mx-auto" data-id="element-128">
            Esto es lo que cambia en tu vida deportiva desde la primera semana
            con el MegaPack Rugby Listo.
          </p>
        </div>

        {/* Time cost callout */}
        <div className="bg-gradient-to-br from-badge-red/15 to-badge-red/5 border-2 border-badge-red/30 rounded-2xl p-5 sm:p-8 mb-10 sm:mb-14 relative overflow-hidden" data-id="element-129">
          <div className="flex flex-col sm:flex-row items-center gap-5 sm:gap-7" data-id="element-130">
            {/* Stat */}
            <div className="flex-shrink-0 flex items-center gap-3 sm:gap-4" data-id="element-131">
              <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-badge-red/20 border border-badge-red/40 flex items-center justify-center flex-shrink-0" data-id="element-132">
                <ClockIcon className="w-7 h-7 sm:w-8 sm:h-8 text-badge-red" strokeWidth={2.2} aria-hidden="true" data-id="element-133" />
              </div>
              <div className="text-left" data-id="element-134">
                <p className="text-badge-red font-black text-3xl sm:text-4xl tracking-tight leading-none" data-id="element-135">
                  180+
                </p>
                <p className="text-text-sec text-xs sm:text-sm font-bold uppercase tracking-wider mt-1" data-id="element-136">
                  Horas / año
                </p>
              </div>
            </div>

            {/* Divider */}
            <div className="hidden sm:block w-px h-16 bg-badge-red/30" aria-hidden="true" data-id="element-137"></div>

            {/* Description */}
            <p className="text-text-main text-sm sm:text-lg font-medium leading-relaxed text-center sm:text-left" data-id="element-138">
              <span className="text-badge-red font-black" data-id="element-139">El costo real:</span>{' '}
              planificar manualmente te quita de{' '}
              <span className="text-badge-red font-black" data-id="element-140">
                4 a 6 horas por semana
              </span>
              . Tiempo que pierdes con tu familia por estar dibujando flechas en
              cuadernos.
            </p>
          </div>
        </div>

        {/* Comparison Table */}
        <div className="bg-bg-alt rounded-2xl sm:rounded-3xl shadow-2xl border border-border-light overflow-hidden" data-id="element-141">
          {/* Header */}
          <div className="grid grid-cols-2 border-b border-border-light bg-bg-dark/40" data-id="element-142">
            <div className="px-4 sm:px-6 py-4 sm:py-5 border-r border-border-light flex items-center gap-2 sm:gap-3" data-id="element-143">
              <span className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-badge-red/20 border border-badge-red/40 flex items-center justify-center flex-shrink-0" aria-hidden="true" data-id="element-144">
                <XIcon className="w-4 h-4 sm:w-5 sm:h-5 text-badge-red" strokeWidth={3} data-id="element-145" />
              </span>
              <div data-id="element-146">
                <p className="font-black text-badge-red text-xs sm:text-sm tracking-widest uppercase leading-tight" data-id="element-147">
                  Sin el Pack
                </p>
                <p className="text-text-sec text-[10px] sm:text-xs font-medium hidden sm:block" data-id="element-148">
                  Improvisación
                </p>
              </div>
            </div>
            <div className="px-4 sm:px-6 py-4 sm:py-5 flex items-center gap-2 sm:gap-3 bg-primary/10" data-id="element-149">
              <span className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-cta-green/20 border border-cta-green/40 flex items-center justify-center flex-shrink-0" aria-hidden="true" data-id="element-150">
                <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-cta-green" strokeWidth={3} data-id="element-151" />
              </span>
              <div data-id="element-152">
                <p className="font-black text-primary text-xs sm:text-sm tracking-widest uppercase leading-tight drop-shadow-[0_0_8px_rgba(59,130,246,0.3)]" data-id="element-153">
                  Con el MegaPack
                </p>
                <p className="text-text-sec text-[10px] sm:text-xs font-medium hidden sm:block" data-id="element-154">
                  Rugby Listo
                </p>
              </div>
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-border-light" data-id="element-155">
            {rows.map((row, i) => {
            const Icon = row.icon;
            return <div key={i} className="grid grid-cols-2 group hover:bg-white/[0.015] transition-colors relative" data-id="element-156">
                  {/* Category bar at top of mobile (overlay) */}
                  <div className="col-span-2 px-4 sm:px-6 pt-3 pb-2 sm:hidden flex items-center gap-2 bg-bg-dark/30 border-b border-border-light" data-id="element-157">
                    <Icon className="w-3.5 h-3.5 text-text-sec" aria-hidden="true" data-id="element-158" />
                    <span className="text-text-sec font-black text-[10px] tracking-widest uppercase" data-id="element-159">
                      {row.category}
                    </span>
                  </div>

                  {/* BEFORE column */}
                  <div className="px-4 sm:px-6 py-4 sm:py-6 flex items-start gap-3 sm:gap-4 border-r border-border-light bg-black/20 relative" data-id="element-160">
                    <div className="hidden sm:flex flex-col items-center gap-2 flex-shrink-0" data-id="element-161">
                      <Icon className="w-4 h-4 text-text-sec opacity-60" aria-hidden="true" data-id="element-162" />
                      <div className="w-6 h-6 rounded-full bg-badge-red/15 flex items-center justify-center border border-badge-red/30" data-id="element-163">
                        <XIcon className="w-3 h-3 text-badge-red" strokeWidth={3} data-id="element-164" />
                      </div>
                    </div>
                    <div className="sm:hidden flex-shrink-0 mt-0.5" data-id="element-165">
                      <div className="w-5 h-5 rounded-full bg-badge-red/15 flex items-center justify-center border border-badge-red/30" data-id="element-166">
                        <XIcon className="w-3 h-3 text-badge-red" strokeWidth={3} data-id="element-167" />
                      </div>
                    </div>
                    <div className="min-w-0" data-id="element-168">
                      <p className="text-text-sec hidden sm:block font-black text-[10px] tracking-widest uppercase mb-1.5" data-id="element-169">
                        {row.category}
                      </p>
                      <p className="text-text-sec font-medium text-[13px] sm:text-base leading-relaxed" data-id="element-170">
                        {row.before}
                      </p>
                    </div>
                  </div>

                  {/* Arrow indicator (desktop) */}
                  <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-bg-alt border-2 border-primary/40 items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.2)] z-10" aria-hidden="true" data-id="element-171">
                    <ArrowRightIcon className="w-4 h-4 text-primary" strokeWidth={2.5} data-id="element-172" />
                  </div>

                  {/* AFTER column */}
                  <div className="px-4 sm:px-6 py-4 sm:py-6 flex items-start gap-3 sm:gap-4 bg-primary/5 relative" data-id="element-173">
                    <div className="hidden sm:flex flex-col items-center gap-2 flex-shrink-0" data-id="element-174">
                      <Icon className="w-4 h-4 text-primary" aria-hidden="true" data-id="element-175" />
                      <div className="w-6 h-6 rounded-full bg-cta-green/20 flex items-center justify-center border border-cta-green/40" data-id="element-176">
                        <CheckIcon className="w-3 h-3 text-cta-green" strokeWidth={3} data-id="element-177" />
                      </div>
                    </div>
                    <div className="sm:hidden flex-shrink-0 mt-0.5" data-id="element-178">
                      <div className="w-5 h-5 rounded-full bg-cta-green/20 flex items-center justify-center border border-cta-green/40" data-id="element-179">
                        <CheckIcon className="w-3 h-3 text-cta-green" strokeWidth={3} data-id="element-180" />
                      </div>
                    </div>
                    <div className="min-w-0" data-id="element-181">
                      <p className="text-primary hidden sm:block font-black text-[10px] tracking-widest uppercase mb-1.5" data-id="element-182">
                        {row.category}
                      </p>
                      <p className="text-text-main font-bold text-[13px] sm:text-base leading-relaxed" data-id="element-183">
                        {row.after}
                      </p>
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-8 sm:mt-12" data-id="element-184">
          <a href="#pricing" className="inline-flex items-center gap-2 text-primary font-bold text-sm sm:text-base hover:text-blue-400 transition-colors border border-primary/30 hover:border-primary/60 bg-primary/5 px-5 py-2.5 rounded-full" data-id="element-185">
            Quiero esta transformación
            <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-186" />
          </a>
        </div>
      </div>
    </section>;
}